// -----------------------------------------------------------------------------
// Slider with gallery trip
// -----------------------------------------------------------------------------

function gallerySliderTrip() {
  $(".gallery-trip__slider").on("init", function (event, slick) {
    if (slick.slideCount > 5) {
      $('.slick-slide[data-slick-index="-2"]').addClass("slick-slide--l2");
    }
    $('.slick-slide[data-slick-index="-1"]').addClass("slick-slide--l1");
    $('.slick-slide[data-slick-index="1"]').addClass("slick-slide--r1");
    if (slick.slideCount > 5) {
      $('.slick-slide[data-slick-index="2"]').addClass("slick-slide--r2");
    }
  });

  $(".gallery-trip__slider").slick({
    slidesToShow: this.slideCount > 5 ? 5 : 3,
    slidesToScroll: 1,
    dots: false,
    infinite: true,
    centerMode: true,
    arrows: true,
    speed: 1000,
    variableWidth: true,
    focusOnSelect: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          focusOnSelect: true,
          draggable: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".gallery-trip__slider").on("beforeChange", function (
    event,
    slick,
    current,
    next
  ) {
    $(".slick-slide.slick-slide--r2").removeClass("slick-slide--r2");
    $(".slick-slide.slick-slide--r1").removeClass("slick-slide--r1");
    $(".slick-slide.slick-slide--l1").removeClass("slick-slide--l1");
    $(".slick-slide.slick-slide--l2").removeClass("slick-slide--l2");

    var lt2 = current < next && current > 0 ? current - 1 : next - 2;
    var lt1 = current < next && current > 0 ? current : next - 1;
    var gt1 = current < next || next === 0 ? next + 1 : current;
    var gt2 = current < next || next === 0 ? next + 2 : current + 1;

    if (slick.slideCount > 5) {
      $(".slick-slide[data-slick-index=" + lt2 + "]").addClass("slick-slide--l2");
    }
    $(".slick-slide[data-slick-index=" + lt1 + "]").addClass("slick-slide--l1");
    $(".slick-slide[data-slick-index=" + gt1 + "]").addClass("slick-slide--r1");
    if (slick.slideCount > 5) {
      $(".slick-slide[data-slick-index=" + gt2 + "]").addClass("slick-slide--r2");
    }
    
    // Clone processing when moving from last to first
    if ((current === (slick.slideCount-1)) && (next === 0)) {
      if (slick.slideCount > 5) {
        $(".slick-slide[data-slick-index=" + (current - 1) + "]").addClass("slick-slide--l2");
      }
      $(".slick-slide[data-slick-index=" + (current) + "]").addClass("slick-slide--l1");
      $(".slick-slide[data-slick-index=" + (current + 1) + "]").addClass("custom-slick-current");
      $(".slick-slide[data-slick-index=" + (current + 2) + "]").addClass("slick-slide--r1");
      if (slick.slideCount > 5) {
        $(".slick-slide[data-slick-index=" + (current + 3) + "]").addClass("slick-slide--r2");
      }
    }

    // Clone processing when moving from first to last
    if ((current === 0) && (next === (slick.slideCount-1))) {
      $(".slick-slide[data-slick-index=" + (current - 1) + "]").addClass("custom-slick-current");
      $(".slick-slide[data-slick-index=" + (current - 2) + "]").addClass("slick-slide--l1");
      if (slick.slideCount > 5) {
        $(".slick-slide[data-slick-index=" + (current - 3) + "]").addClass("slick-slide--l2");
      }
      $(".slick-slide[data-slick-index=" + current + "]").addClass("slick-slide--r1");
      if (slick.slideCount > 5) {
        $(".slick-slide[data-slick-index=" + (current + 1) + "]").addClass("slick-slide--r2");
      }
    }
  });

  $('.gallery-trip__slider').on('afterChange', function(e, slick, currentSlide, nextSlide) {
    $('.custom-slick-current').removeClass('custom-slick-current');
  })
}
